import { createContext, useContext, useState, useCallback, useEffect, useRef, useMemo } from 'react';

interface StateProps {
  isPasskeySupport: boolean | null;
  isDark: boolean;
  userInfo?: any;
}

interface ContextProps extends StateProps {
  isSubAcc: boolean;
  updateState: (arg?: Partial<StateProps>) => void;
}

const defaultState: StateProps = {
  isPasskeySupport: null,
  isDark: false,
};

const defaultContext: ContextProps = {
  ...defaultState,
  isSubAcc: false,
  updateState: () => {},
};

const StoreContext = createContext(defaultContext);

export const withStore = (Component) => {
  return (props) => {
    const stateRef = useRef<StateProps>(defaultState);
    const [state, setState] = useState<StateProps>(defaultState);

    const isSubAcc = useMemo(() => {
      const { userInfo } = state;
      return !!(userInfo && userInfo.userAccountLevel === 2);
    }, [state]);
    const updateState = useCallback((payload?: Partial<StateProps>) => {
      stateRef.current = {
        ...stateRef.current,
        ...(payload || {}),
      }
      setState(stateRef.current);
    }, [state]);

    useEffect(() => {
      let isPasskeySupport = false;
      if (window.navigator && window.navigator.credentials) {
        isPasskeySupport = true;
      }
      updateState({isPasskeySupport});
    }, []);

    return (
      <StoreContext.Provider value={{
        ...state,
        isSubAcc,
        updateState,
      }}>
        <Component {...props} />
      </StoreContext.Provider>
    )
  }
};

export const useStore = () => {
  const context = useContext(StoreContext);
  return context;
};
